import React from 'react';
import { makeStyles, Typography, Grid } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { useAiServices } from 'hooks';
import { setSelectedPicture, setCanProceed } from 'state/slices/aiServices';
import { COLOR } from 'config/constants';
import InfoRoundedIcon from '@material-ui/icons/InfoRounded';
import { useIntl } from 'react-intl';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    marginTop: 20,
  },
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'row',
    width: '100%',
    minHeight: '80vh',
    borderRadius: 8,
    backgroundColor: COLOR.ULTRA_LIGHT_GREY,
    '@media (min-width: 768px)': {
      minWidth: 500,
    },
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    padding: 20,
  },
  title: {
    fontSize: 16,
    fontFamily: 'FordAntenna-Medium',
    marginBottom: 10,
  },
  subtitle: {
    fontSize: 15,
    fontFamily: 'FordAntenna-Medium',
    marginBottom: 10,
  },
  infoBox: {
    borderRadius: 5,
    fontSize: 14,
    padding: 5,
    width: '80%',
    height: 'fit-content',
    display: 'flex',
    alignItems: 'center',
    border: `solid ${COLOR.LIGHT_BLUE} 1px`,
    marginBottom: 10,
    '@media (max-width: 768px)': {
      fontSize: 10,
      width: '100%',
    },
  },
  infoBoxIcon: {
    marginRight: 5,
  },
  picturesBox: {
    display: 'flex',
    flexWrap: 'wrap',
    overflowY: 'auto',
    maxHeight: '80%',
    width: '100%',
    borderRadius: 5,
    paddingTop: 10,
    paddingBottom: 10,
    backgroundColor: COLOR.LIGHT_GREY,
    '& img': {
      width: '100%',
      borderRadius: 5,
      cursor: 'pointer',
    },
  },
  imagePreview: {
    marginBottom: 10,
    width: '40%',
    '@media (max-width: 1050px)': {
      width: '80%',
    },
    '@media (max-width: 768px)': {
      width: '100%',
    },
  },
});

function SelectPicture() {
  const dispatch = useDispatch();
  const classes = useStyles();
  const { selectedPicture, listing_pictures } = useAiServices();
  const intl = useIntl();

  const fmtAIVirtualStaging = intl.formatMessage({
    id: 'deliver.aiServices.aiVirtualStaging',
  });
  const fmtSelectPhoto = intl.formatMessage({
    id: 'deliver.aiServices.selectPhoto',
  });
  const fmtDisclaimerPictureSelection = intl.formatMessage({
    id: 'deliver.aiServices.disclaimerPictureSelection',
  });
  function onPictureSelect(picture: any) {
    dispatch(setSelectedPicture(picture));
    dispatch(setCanProceed(true));
  }
  return (
    <div className={classes.root}>
      <Typography className={classes.title}>{fmtAIVirtualStaging}</Typography>
      <div className={classes.container}>
        <div className={classes.content}>
          <Typography className={classes.subtitle}>{fmtSelectPhoto}</Typography>
          <Typography className={classes.infoBox}>
            <InfoRoundedIcon className={classes.infoBoxIcon} color='secondary' />
            {fmtDisclaimerPictureSelection}
          </Typography>
          <Grid container spacing={2} className={classes.picturesBox}>
            {listing_pictures.map((picture: any, index: number) => {
              return (
                <Grid item sm={4} xs={12} key={index}>
                  <img
                    key={picture.id}
                    src={picture.thumbnail_url}
                    alt={picture.id}
                    style={
                      selectedPicture && selectedPicture.id === picture.id
                        ? { outline: `solid ${COLOR.LIGHT_BLUE} 5px` }
                        : {}
                    }
                    onClick={() => {
                      return onPictureSelect(picture);
                    }}
                  />
                </Grid>
              );
            })}
          </Grid>
        </div>
      </div>
    </div>
  );
}

export default SelectPicture;
